import { useQuery } from '@tanstack/react-query';
import type { AuditLog } from '@storeflare/types';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Skeleton } from '@/components/ui/skeleton';
import { EmptyState, Page } from '@/components/Page';
import { api } from '@/lib/api';

export function AuditPage() {
  const logs = useQuery({
    queryKey: ['audit-logs'],
    queryFn: () => api<AuditLog[]>('/v1/audit-logs?limit=100'),
  });

  return (
    <Page title="Audit log" subtitle="Every mutating action is recorded.">
      {logs.isLoading ? (
        <Skeleton className="h-40 w-full" />
      ) : !logs.data || logs.data.length === 0 ? (
        <EmptyState title="No activity yet" />
      ) : (
        <div className="rounded-lg border">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Time</TableHead>
                <TableHead>Action</TableHead>
                <TableHead>Resource</TableHead>
                <TableHead className="text-right">IP</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {logs.data.map((l) => (
                <TableRow key={l.id}>
                  <TableCell className="whitespace-nowrap text-xs font-mono text-muted-foreground">
                    {new Date(l.created_at).toLocaleString()}
                  </TableCell>
                  <TableCell className="font-medium">{l.action}</TableCell>
                  <TableCell className="truncate text-muted-foreground">
                    {l.resource_type}/{l.resource_id ?? '-'}
                  </TableCell>
                  <TableCell className="truncate text-right text-xs text-muted-foreground">
                    {l.ip ?? ''}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
    </Page>
  );
}
